module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Medium.1e4ccbae.ttf";